export const convertS3UriToHttpsUrl = (s3Uri: string) => {
	const parts = s3Uri?.split("/");
	const bucketName = parts && parts[2];
	const filePath = parts && parts.slice(3).join("/");
	const region = "us-east-1";

	return `https://${bucketName}.s3.${region}.amazonaws.com/${filePath}`;
};

export const getImageMeta = (url: string) =>
	new Promise<HTMLImageElement>((resolve, reject) => {
		const image = new Image();
		image.addEventListener("load", () => resolve(image));
		image.addEventListener("error", (error) => reject(error));
		image.setAttribute("crossOrigin", "anonymous");
		image.src = url;
	});

export const runInChunks = async (taskFns: any[], chunkSize = 6) => {
	const results = [];
	const start = performance.now();

	for (let i = 0; i < taskFns.length; i += chunkSize) {
		const chunkStart = performance.now();
		const chunk = taskFns.slice(i, i + chunkSize);
		const chunkResults = await Promise.all(chunk.map((fn) => fn()));
		results.push(...chunkResults);
		const chunkEnd = performance.now();
		console.log(`Task Chunk [${i}-${i + chunkSize}] completed in ${(chunkEnd - chunkStart) / 1000} seconds`);
	}

	const end = performance.now();
	console.log(`All tasks completed in ${(end - start) / 1000} seconds`);

	return results;
};
